import { paddingZero } from '../../../src/util/common.js'

let now = new Date();
let Hours = [];
let Minutes = [];
let Seconds = [];
let Years = [];
let Months = [];
let Dates = [];
let beginYear = now.getFullYear() - 60/2;


for(let i = 0; i < 60; i++) {
    if(i < 12) {
        Months.push(paddingZero(i+1))
    }
    if(i < 24) {
        Hours.push(paddingZero(i))
    }
    if(i< 31) {
        Dates.push(paddingZero(i+1))
    }
    Minutes.push(paddingZero(i))
    Seconds.push(paddingZero(i))
    Years.push(beginYear + i)
}

export {
    Hours,
    Minutes,
    Seconds,
    Years,
    Months,
    Dates,
}
